import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, OutlinedInput, TextField, Typography } from "@mui/material";
import { Mounting, Shielding, Units } from "../../../../common/const";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";

export default function WeightMeasures({
    weightData,
    setWeightData,
}) {
    return (
        <Grid container>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10, paddingBottom: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Dimensions</Typography>
                </Box>
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Autocomplete
                            value={Units.find((c) => c.value === weightData?.unit) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            clearIcon={null}
                            options={Units}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                if (newValue?.value === 'imperial') {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        width: Number(weightData?.width / 25.4).toFixed(2),
                                        height: Number(weightData?.width / 25.4).toFixed(2),
                                        depth: Number(weightData?.depth / 25.4).toFixed(2),
                                        weight: Number(weightData?.weight * 2.205).toFixed(2),
                                        shipWeight: Number(weightData?.shipWeight * 2.205).toFixed(2),
                                        clearance: {
                                            ...prevData.clearance,
                                            left: Number(weightData?.clearance?.left / 25.4).toFixed(2),
                                            right: Number(weightData?.clearance?.right / 25.4).toFixed(2),
                                            top: Number(weightData?.clearance?.top / 25.4).toFixed(2),
                                            bottom: Number(weightData?.clearance?.bottom / 25.4).toFixed(2),
                                            front: Number(weightData?.clearance?.front / 25.4).toFixed(2),
                                            back: Number(weightData?.clearance?.back / 25.4).toFixed(2),
                                        }
                                    }));
                                } else if (newValue?.value === 'matric' || Units[0]?.value) {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        width: Math.ceil(Number(weightData?.width * 25.4).toFixed(2)),
                                        height: Math.ceil(Number(weightData?.width * 25.4).toFixed(2)),
                                        depth: Math.ceil(Number(weightData?.depth * 25.4).toFixed(2)),
                                        weight: Math.ceil(Number(weightData?.weight / 2.205).toFixed(2)),
                                        shipWeight: Math.ceil(Number(weightData?.shipWeight / 2.205).toFixed(2)),
                                        clearance: {
                                            ...prevData.clearance,
                                            left: Math.ceil(Number(weightData?.clearance?.left * 25.4).toFixed(2)),
                                            right: Math.ceil(Number(weightData?.clearance?.right * 25.4).toFixed(2)),
                                            top: Math.floor(Number(weightData?.clearance?.top * 25.4).toFixed(2)),
                                            bottom: Math.floor(Number(weightData?.clearance?.bottom * 25.4).toFixed(2)),
                                            front: Math.floor(Number(weightData?.clearance?.front * 25.4).toFixed(2)),
                                            back: Math.floor(Number(weightData?.clearance?.back * 25.4).toFixed(2)),
                                        }
                                    }));
                                }
                                setWeightData((prevData) => ({
                                    ...prevData,
                                    unit: newValue?.value || Units[0]?.value
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Units" name="Units" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Width ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Width (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.width}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        width: e.target.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Height ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Height (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.height}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        height: e.target.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Depth ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Depth (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.depth}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        depth: e.target.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.adjustableWidth}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                adjustableWidth: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Adjustable Width"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.adjustableDepth}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                adjustableDepth: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Adjustable Depth"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.adjustableHeight}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                adjustableHeight: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Adjustable Height"
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10, paddingBottom: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Weights</Typography>
                </Box>
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Autocomplete
                            value={Mounting.find((c) => c.value === weightData?.mounting) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={Mounting}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setWeightData((prevData) => ({
                                    ...prevData,
                                    mounting: newValue?.value
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Mounting" name="Mounting" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Weight ({weightData?.unit === 'matric' ? 'kg' : 'lbs'})</InputLabel>
                            <OutlinedInput
                                label={`Weight (${weightData?.unit === 'matric' ? 'kg' : 'lbs'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.weight}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        weight: e.target.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Ship Weight ({weightData?.unit === 'matric' ? 'kg' : 'lbs'})</InputLabel>
                            <OutlinedInput
                                label={`Ship Weight (${weightData?.unit === 'matric' ? 'kg' : 'lbs'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.shipWeight}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        shipWeight: e.target.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10, paddingBottom: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Clearance</Typography>
                </Box>
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Left ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Left (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.clearance?.left}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        clearance: {
                                            ...prevData.clearance,
                                            left: e.target?.value
                                        }
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Right ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Right (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.clearance?.right}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        clearance: {
                                            ...prevData.clearance,
                                            right: e.target?.value
                                        }
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Front ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Front (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.clearance?.front}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        clearance: {
                                            ...prevData.clearance,
                                            front: e.target?.value
                                        }
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Back ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Back (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.clearance?.back}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        clearance: {
                                            ...prevData.clearance,
                                            back: e.target?.value
                                        }
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Top ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Top (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.clearance?.top}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        clearance: {
                                            ...prevData.clearance,
                                            top: e.target?.value
                                        }
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Bottom ({weightData?.unit === 'matric' ? 'mm' : 'in'})</InputLabel>
                            <OutlinedInput
                                label={`Bottom (${weightData?.unit === 'matric' ? 'mm' : 'in'})`}
                                id="standard-adornment-password"
                                type='number'
                                value={weightData?.clearance?.bottom}
                                onChange={(e) => {
                                    setWeightData((prevData) => ({
                                        ...prevData,
                                        clearance: {
                                            ...prevData.clearance,
                                            bottom: e.target?.value
                                        }
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10, paddingBottom: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Attributes</Typography>
                </Box>
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.ada}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                ada: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="DA Compliant"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.green}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                green: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Green"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.antiMicrobial}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                antiMicrobial: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Anti-Microbial"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={weightData?.seismic}
                                        onClick={(e) => {
                                            setWeightData((prevData) => ({
                                                ...prevData,
                                                seismic: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Seismic"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Autocomplete
                            value={Shielding.find((c) => c.value === weightData?.shielding) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={Shielding}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setWeightData((prevData) => ({
                                    ...prevData,
                                    shielding: newValue?.value
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Shielding" name="Shielding" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Spatial Remarks</InputLabel>
                            <OutlinedInput
                                label="Spatial Remarks"
                                id="standard-adornment-password"
                                type='text'
                                multiline
                                minRows={5}
                                value={weightData?.spatialRemarks}
                                onChange={(e) => {
                                    if (e.target.value?.length > 300) {
                                        showNotification('The Remarks should be maximum 300 characters long', 'error');
                                    } else {
                                        setWeightData((prevData) => ({
                                            ...prevData,
                                            spatialRemarks: e.target.value,
                                        }));
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}